import { FIELD_BLANK_VALUES } from './constants';

import type { PublishingForm } from './types';

export function formatPublishingForm(publishingForm: any): PublishingForm {
  return {
    id: publishingForm?.id ?? NaN,
    // Integration readiness & API ownership.
    hasApiOwnership:
      publishingForm?.has_api_ownership ?? FIELD_BLANK_VALUES.hasApiOwnership,
    apiEndpointsUsed:
      publishingForm?.api_endpoints_used ?? FIELD_BLANK_VALUES.apiEndpointsUsed,
    ownsAllEndpoints:
      publishingForm?.owns_all_endpoints ?? FIELD_BLANK_VALUES.ownsAllEndpoints,
    hasPermissionForEndpoints:
      publishingForm?.has_permission_for_endpoints ??
      FIELD_BLANK_VALUES.hasPermissionForEndpoints,
    usesProductionEndpoints:
      publishingForm?.uses_production_endpoints ??
      FIELD_BLANK_VALUES.usesProductionEndpoints,
    paidApi: publishingForm?.paid_api ?? FIELD_BLANK_VALUES.paidApi,
    // Test account for us.
    testAccountUsername:
      publishingForm?.test_account_username ??
      FIELD_BLANK_VALUES.testAccountUsername,
    testAccountPassword:
      publishingForm?.test_account_password ??
      FIELD_BLANK_VALUES.testAccountPassword,
    testAccountOnlySupportsSso:
      publishingForm?.test_account_only_supports_sso ??
      FIELD_BLANK_VALUES.testAccountOnlySupportsSso,
    ssoTestAccountCreated:
      publishingForm?.sso_test_account_created ??
      FIELD_BLANK_VALUES.ssoTestAccountCreated,
    testAccountNotes:
      publishingForm?.test_account_notes ?? FIELD_BLANK_VALUES.testAccountNotes,
    // App details.
    hasBeenLaunched:
      publishingForm?.has_been_launched ?? FIELD_BLANK_VALUES.hasBeenLaunched,
    isReplacementIntegration:
      publishingForm?.is_replacement_integration ??
      FIELD_BLANK_VALUES.isReplacementIntegration,
    alreadyManagingSimilarIntegration:
      publishingForm?.already_managing_similar_integration ??
      FIELD_BLANK_VALUES.alreadyManagingSimilarIntegration,
    linkToOtherIntegrations:
      publishingForm?.link_to_other_integrations ??
      FIELD_BLANK_VALUES.linkToOtherIntegrations,
    newIntegrationRationale:
      publishingForm?.new_integration_rationale ??
      FIELD_BLANK_VALUES.newIntegrationRationale,
    homepageUrl: publishingForm?.homepage_url ?? FIELD_BLANK_VALUES.homepageUrl,
    apiDocsUrl: publishingForm?.api_docs_url ?? FIELD_BLANK_VALUES.apiDocsUrl,
    apiDocumentationNotes:
      publishingForm?.api_documentation_notes ??
      FIELD_BLANK_VALUES.apiDocumentationNotes,
    primaryColor:
      publishingForm?.primary_color ?? FIELD_BLANK_VALUES.primaryColor,
    twitterUsername:
      publishingForm?.twitter_username ?? FIELD_BLANK_VALUES.twitterUsername,
    // Contact details.
    marketingContactEmail:
      publishingForm?.marketing_contact_email ??
      FIELD_BLANK_VALUES.marketingContactEmail,
    technicalContactEmail:
      publishingForm?.technical_contact_email ??
      FIELD_BLANK_VALUES.technicalContactEmail,
    expectedResponseTime:
      publishingForm?.expected_response_time ??
      FIELD_BLANK_VALUES.expectedResponseTime,
    // Compliance & platform rules.
    companyBaseCountry:
      publishingForm?.company_base_country ??
      FIELD_BLANK_VALUES.companyBaseCountry,
    transmitsSensitiveValues:
      publishingForm?.transmits_sensitive_values ??
      FIELD_BLANK_VALUES.transmitsSensitiveValues,
    collectsFinancialInfo:
      publishingForm?.collects_financial_info ??
      FIELD_BLANK_VALUES.collectsFinancialInfo,
    usesThirdPartyApis:
      publishingForm?.uses_third_party_apis ??
      FIELD_BLANK_VALUES.usesThirdPartyApis,
    permissionForThirdPartyApis:
      publishingForm?.permission_for_third_party_apis ??
      FIELD_BLANK_VALUES.permissionForThirdPartyApis,
    usesZapierBranding:
      publishingForm?.uses_zapier_branding ??
      FIELD_BLANK_VALUES.usesZapierBranding,
    usesCurrentZapierBranding:
      publishingForm?.uses_current_zapier_branding ??
      FIELD_BLANK_VALUES.usesCurrentZapierBranding,
  };
}
